
import {
  CategoriaDto,
  PrecoProfissionalDto,
  ProfissionalDto,
  ProfissionalHorarioDto,
  UnidadeDto
} from "../agendamento.types";
import ServiceAPI from "./serviceapi";

const PATH = "/agendamento";

export const AgendamentoService = {
  listarServicos: (codigoUnidade : number) =>
    ServiceAPI.get<CategoriaDto[]>(`${PATH}/servicos`, { params: { codigoUnidade } }),

  listarUnidades: (tenancy : string) =>
    ServiceAPI.get<UnidadeDto[]>(`${PATH}/unidades`),

  listarHorarios: (codigoProduto: number, codigoUnidade: number ) =>
    ServiceAPI.get<ProfissionalHorarioDto[]>(
      `${PATH}/horarios`,
      { params: { codigoProduto, codigoUnidade } }
    ),

  listarProfissionais: (
    servicoId: number,
    horarioInicio: string
  ) =>
    ServiceAPI.get<ProfissionalDto[]>(
      `${PATH}/profissionais`,
      { params: { servicoId, horarioInicio } }
    ),

  buscarPreco: (servicoId: number, profissionalId: number) =>
    ServiceAPI.get<PrecoProfissionalDto>(
      `${PATH}/preco`,
      { params: { servicoId, profissionalId } }
    ),

  agendar: (resumo: any) =>
    ServiceAPI.post<any>(`${PATH}/agendar`, resumo),

    consultar: (resumo: any) =>
    ServiceAPI.post<any>(`${PATH}/consultar`, resumo),
};
